import ScalebarEditor from "./ScalebarEditor";
export default function ScalebarMenu({data,onEvent}){


  if( data.computed.value === '?' ){
    return (
      <div class="fair-margin">
        Set image resolution
      </div>
    )
  }

  return <ScalebarEditor data={data} onEvent={onEvent}/>


}
